<header class="top-bar">
  <div class="breadcrumb">
    <ng-container *ngFor="let item of items; let i = index; let last = last">
      <a *ngIf="!last && item.link; else staticTpl"
         class="breadcrumb__link"
         [class.breadcrumb__parent]="i > 0"
         [routerLink]="item.link">{{ item.label }}</a>
      <ng-template #staticTpl>
        <span
          [class.breadcrumb__parent]="i > 0 && !last"
          [class.breadcrumb__current]="last"
        >{{ item.label }}</span>
      </ng-template>
      <span *ngIf="!last" class="breadcrumb__separator">/</span>
    </ng-container>
  </div>
</header>
